(function($) {
$(function(){
	window.onload = function() {
		scroll_effect();
		$(window).scroll(function(){
			scroll_effect();
		});
	
	function scroll_effect(){
		$('.effect-fade').each(function(){
			var elemPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > elemPos - windowHeight){
				$(this).addClass('effect-scroll');
			}
		});
	}
	};
});
})(jQuery);

// 動画が画面内に入ったら再生、出たら停止のスクリプト
	(function($){
	$(function() {
	function playVideos(videos) {
		const startPosition = $(window).scrollTop() + $(window).height();
		videos.each(function(index) {
			if(startPosition > $(this).offset().top) {
			$(this).get(0).play();
			}
		});
	}
	$(window).on('load', function() {
		const videos = $('.ss-2025ss > video');
		if(videos.length) {
			playVideos(videos);
			$(window).on('scroll', function() {
				playVideos(videos);
			});
		}
	});
	$(window).on('load', function() {
		const videos = $('.ss-2024aw > video');
		if(videos.length) {
			playVideos(videos);
			$(window).on('scroll', function() {
				playVideos(videos);
			});
		}
	});
	});
})(jQuery);

(function($){	// 動画用スペック表示ボタン
	$(function() {
		$('.stylingBtn').on('click', function () {
			$(this).next('.stylingBlock').slideToggle();
			$(this).toggleClass('btnOff');
		});
	});
})(jQuery);

(function($){
	$(function() {
		//swiper 960以下で起動
		var swiper; 
		$(window).on('load resize', function(){
			var w = $(window).width();
			if (w <= 960) {
				if (swiper) {
					return;
				} else {
					swiper = new Swiper('.swiper-container', {
					loop: true,
		//			autoplay: {
		//				delay: 7000,
		//				disableOnInteraction: false,
		//			},
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
				},
			});
			}
			} else {
				if (swiper) {
					swiper.destroy();
					swiper = undefined;
				} 
			} 
		});
	});
})(jQuery);



(function($){
document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});
})(jQuery);

